<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <div class="switch_box">
          <span style="margin-right: 16px;font-weight: 700;">全部员工</span>
          <el-switch v-model="val" active-text="开" inactive-text="关" active-color="#13ce66" inactive-color="#ff4949" />
          <span style="margin-left: 15px;color: brown;" class="warning-text"> 注意:关闭时选择员工才会生效</span>
        </div>
        <!-- @change="all" -->

        <div class="serch_box">
          <!-- :rules="rules"  -->
          <!-- <el-form :validate-on-rule-change="false" label-width="70px" style="width: 400px;" :model="obr"> -->
          <el-form
            ref="form"
            :rules="rules"
            label-width="70px"
            style="width: 400px;"
            :model="form"
            :validate-on-rule-change="false"
          >
            <el-form-item label="添加时间">
              <el-col :span="8">
                <!-- <el-form-item prop="communication_hour_min">
              <el-input v-model="form.communication_hour_min" v-numericonly placeholder="请输入数字" />
            </el-form-item> -->
                <el-form-item prop="hour_min">
                  <el-form-item>
                    <el-input v-model="form.hour_min" v-numericonly placeholder="请输入数字" />
                  </el-form-item>
                </el-form-item></el-col>
              <el-col class="line" :span="2">
                <span style="margin-left: 4px;">---</span>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="hour_max">

                  <!-- <el-form-item> -->
                  <el-input v-model="form.hour_max" v-numericonly placeholder="请输入数字" />
                  <!-- <el-input v-model="form.hour_max" v-numericonly placeholder="请输入数字" /> -->
                </el-form-item>
              </el-col><span style="margin:2px 5px;">点</span>
            </el-form-item>
            <el-form-item label="添加人次" prop="add_num" :hide-required-aterisk="false">
              <!-- <el-form-item label="添加人次"> -->
              <!-- <div class="conter"> -->
              <el-input v-model="form.add_num" v-numericonly value="2" placeholder="请输入数字" />
              <!-- </div> -->
            </el-form-item>
          </el-form>

        </div>

      </div>

    </div>

    <div class="select-box">
      <div>
        <el-checkbox v-model="fullName" style="margin-bottom:15px ;" @change="whole">全选</el-checkbox>
        <div class="checkbox-list">
          <div v-for="(item, index) in arr" :key="item.id" class="checkbox-item">
            <el-checkbox v-model="item.checked" @click.native.stop @change="itenclick(item, index)">{{ item.label
            }}</el-checkbox>
          </div>
        </div>
      </div>
      <div style="display:flex;" class="selected-box">
        <div class="vertical-line" />
        <div>
          <div>
            <div style="margin-bottom:15px ;">选中的员工</div>
            <el-tag
              v-for="(tag, index) in arrs"
              :key="tag.user_id"
              closable
              style="margin-right:10px;margin-bottom:5px"
              :type="tag.type"
              @close="rightclick(tag.user_id, index)"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <pagination-right
      style="padding:0px;margin-top:20px"
      :total="total"
      :current-page="obr.page"
      :page-size="obr.pageSize"
      :page-sizes="[10, 50, 100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div class="que_box">
      <el-button type="primary" @click="submit">确定</el-button>
      <!-- <el-button type="primary">确定</el-button> -->
    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { spCorpcorpUsersList } from '@/api/officialaccount.js'
import { addFriends, friendConfigUpdate } from '@/api/friendsConfig'
export default {
  components: {
    PaginationRight
  },
  directives: {
    numericonly: {
      bind: function(el) {
        el.addEventListener('input', function(e) {
          if (/\D/.test(e.target.value)) {
            e.target.value = e.target.value.replace(/\D/g, '')
          }
        })
      }
    }
  },
  mixins: [convertToHump],
  props: {
    // parentData: {

    classify: {
      type: Number,
      default: 0
    },
    idRow: {
      type: Number,
      default: 0
    },
    allData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: ''
    }

    // }
  },
  data() {
    return {
      userids: [],
      val: true,
      weekValue: '',
      monthValue: '',
      radio: '3',
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: 1, // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: {},
      user: [],
      newarrs: [],
      obr: {
        user_id: null,
        name: null,
        sp_strategy_no: null,
        page: 1,
        pageSize: 50,
        corp_id: null,
        keywords: null,
        region: ''
      },
      total: null,
      sp_strategy_no: null,
      pickerOptions: {
        disabledDate(date) {
          // 禁用非本年的所有日期
          const now = new Date()
          return date.getFullYear() !== now.getFullYear()
        }
      },
      form: {
        hour_min: 10,
        hour_max: 20,
        add_num: 10 // 人比例
      },
      rules: {
        add_num: [{ required: true, message: '请输入添加人次', trigger: ['blur', 'change'] },
          { pattern: /^([1-9]\d*|0)(\.\d+)?$/, message: '添加不能小于0', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('添加人次不能小于0'))
              } else {
                callback()
              }
            }, trigger: 'change'
          }],
        hour_min: [
          { required: true, message: '必填', trigger: 'blur' },
          { pattern: /^([1-9]\d*|0)(\.\d+)?$/, message: '最数不能小于0', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入最小值'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (this.form.hour_max !== null && Number(value) >= Number(this.form.hour_max)) {
                callback(new Error('值不能大于等于第二个框'))
              } else {
                this.$refs.form.clearValidate('hour_min')
                callback()
              }
              if (value < 0) {
                callback(new Error('最小数不能小于0'))
              } else {
                callback()
              }
            }, trigger: 'change'
          }
        ],
        hour_max: [
          { required: true, message: '必填', trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              const regexp = /^([1-9]\d*|0)(\.\d+)?$/
              if (value === '') {
                callback(new Error('请输入最大值'))
              } else if (isNaN(value)) {
                callback(new Error('请输入数字值'))
              } else if (this.form.hour_min !== null && Number(value) <= Number(this.form.hour_min)) {
                callback(new Error('值不能小于或等于第一个框'))
              } if (!regexp.test(value)) {
                callback(new Error('最大小时数必须为非负数'))
              } else if (parseFloat(value) > 23) {
                callback(new Error('小时数不能大于23'))
              } else {
                this.$refs.form.clearValidate('hour_max')
                callback()
              }
            }, trigger: 'change'
          }

        ]
      }
    }
  },
  computed: {
    fullName: {
      get() {
        return this.arr.every(item => item.checked)
      },
      set(value) {
        this.arr.forEach(item => {
          item.checked = value
        })
      }
    }
  },
  watch: {
    // parentData(val) {
    //   console.log('传入的类型是：', val)
    //   this.$nextTick(() => {
    //     this.allCheckout()
    //   })
    classify(newVal, oldVal) {
      console.log('newVal val', newVal)
      console.log('oldVal val', oldVal)

      if (newVal.length > 0) {
        console.log('newVal', newVal)
        this.$nextTick(() => {
          // this.allCheckout()
        })
      }
    },
    // allData(newVal, oldVal) {
    //   console.log('newVal val', newVal)
    //   console.log('oldVal val', oldVal)

    //   if (newVal > 0) {
    //     console.log('newVal', newVal)
    //     this.$nextTick(() => {
    //       // this.allCheckout()
    //     })
    //   }
    // },
    idRow(newVal, oldVal) {
      console.log('newVal val', newVal)
      console.log('oldVal val', oldVal)

      if (newVal.length > 0) {
        console.log('newVal', newVal)
        this.$nextTick(() => {
          // this.allCheckout()
        })
      }
    },
    //   console.log('传入的类型是：', this.classify)
    //   console.log('传入的类型是：', this.allData)
    // },
    immediate: true,
    deep: true
  },

  created() {
    // console.log('传入的类型是：', this.n + 1, this.classify)
    // this.form.hour_min = this.classify === 1 ? this.allData.min_hour : 8
    // this.form.hour_max = this.classify === 1 ? this.allData.max_hour : 12
    // this.form.add_num = this.classify === 1 ? this.allData.add_num : 2
    // this.$nextTick(() => {
    //   this.allCheckout()
    // })
    // this.allCheckout()
    // console.log('传入的类型是：', this.classify)
    // console.log('传入的类型是：', this.allData)
  },
  mounted() {
    this.list()
  },
  methods: {
    closedata() {
      this.$refs.form.resetFields()
      this.form.hour_min = 10
      this.form.hour_max = 20
      this.form.add_num = 10 // 人比例
      this.arr = []
      this.arrs = []
      this.user = []
      this.newarrs = []
    },
    secahclkick() {
      this.obr.page = 1
      this.list()
    },
    // 点击确定
    async submit() {
      console.log(1)
      this.$refs.form.validate(async(result) => {
        if (result) {
          if (!this.val) {
            if (this.arrs.length === 0) {
              this.$message.error('请选择要绑定的员工')
              return
            }
          }
          let user = ''
          if (!Array.isArray(this.user)) {
            const arr = this.user.split(',')
            user = [...new Set(arr)].join(',')
          } else {
            user = [...new Set(this.user)].join(',')
          }
          if (this.mode === 'add') {
            console.log(this.val, 'this.val  add')
            await addFriends({
              corp_primary_id: this.$route.query.corp_id,
              is_all: this.val === true ? 1 : 2,
              user,
              add_num: this.form.add_num,
              min_hour: this.form.hour_min,
              max_hour: this.form.hour_max
            })
          } else {
            await friendConfigUpdate({
              corp_primary_id: this.$route.query.corp_id,
              is_all: this.val === true ? 1 : 2,
              user,
              add_num: this.form.add_num,
              min_hour: this.form.hour_min,
              max_hour: this.form.hour_max,
              // max_hour: 20,
              id: this.idRow
            })
          }
          this.$message({
            message: this.mode === 'add' ? '添加成功' : '修改成功',
            type: 'success'
          })
          this.$emit('bandarr', this.user)
        }
      })
    },
    // 点击单选
    itenclick(item, index) {
      if (item.checked === true) {
        this.arrs.push({ user_id: item.user_id, name: item.label, id: item.id })
      } else {
        const index = this.arrs.findIndex(v => v.user_id === item.user_id)
        if (index !== -1) {
          this.arrs.splice(index, 1)
          this.userids.splice(index, 1)
        }
      }
      this.user = [...new Set(this.arrs.map(item => item.id))]
    },

    whole(e) {
      if (!e) {
        // console.log('666 ')
        let index = ''
        this.arr.forEach((item) => {
          if (item.checked === false) {
            index = this.arrs.findIndex((items) => {
              return items.user_id === item.user_id
            })
          }
          this.arrs.splice(index, 1)
          this.userids.splice(index, 1)
        })
      } else {
        // console.log(77, '全选')
        this.arr.forEach((item) => {
          // console.log(item)
          if (item.checked === true) {
            this.arrs.map(re => re.user_id).includes(item.user_id) || this.arrs.push({ user_id: item.user_id, name: item.label, id: item.id })
          }
        })
      }
      this.user = [...new Set(this.arrs.map(item => item.id))]
    },
    rightclick(user_id, index) {
      console.log(user_id, index, 'user_id, index')
      this.arrs.splice(index, 1)
      this.arr.findIndex((items) => {
        if (items.user_id === user_id) {
          items.checked = false
        }
      })
      this.user = [...new Set(this.arrs.map(item => item.id))]
    },
    async list() {
      this.obr.corp_id = this.$route.query.chatid
      const data = await spCorpcorpUsersList(this.obr)
      this.total = data.data.total
      this.arr = data.data.list.map(item => {
        return {
          id: item.employee_no,
          label: item.name,
          checked: false,
          user_id: item.user_id
        }
      })
      if (this.arrs.length > 0) {
      //   console.log(11)
        if (this.mode === 'add') {
          this.arrs.forEach(item => {
            this.arr.forEach((items) => {
              if (item.user_id === items.user_id) {
                items.checked = true
              }
            })
          })
        }
      // else {
      //     console.log('type---2', this.arrs)A
      //     this.arrs.forEach(item => {
      //       this.arr.forEach((items) => {
      //         if (item.user_id === items.user_id) {
      //           items.checked = true
      //         }
      //       })
      //     })
      //   }
      }
      if (this.mode === 'edit') {
        console.log(22)
        this.arrs = []
        if (this.allData.is_all === 2) {
          this.val = false
        } else {
          this.val = true
        }
        this.form.hour_min = this.allData.min_hour
        this.form.hour_max = this.allData.max_hour
        this.form.add_num = this.allData.add_num
        const newarr = Object.values(this.allData.user_str).map(item => {
          return {
            name: item.name,
            id: item.employee_no,
            user_id: item.user_id
          }
        })
        // console.log(this.allData, 'this.allData------')
        if (this.value1 === 1) {
          newarr.filter(item => {
            this.arrs.push({
              name: item.name,
              user_id: item.user_id,
              id: item.id
            })
            this.arr.forEach(items => {
              if (items.user_id === item.user_id) {
                items.checked = true
              }
            })
          })
        } else {
          console.log(newarr, 'newarr', this.userids)
          this.arrs = this.newarrs
          this.arrs.filter(item => {
            this.arr.forEach(items => {
              if (items.user_id === item.user_id) {
                items.checked = true
              }
            })
          })
        }

        this.userids = newarr
        this.user = [...new Set(this.arrs.map(item => item.id))]
      }
    },
    // 分页
    fetchPageSize(e) {
      this.newarrs = []
      this.newarrs = this.arrs
      // console.log('111')
      this.obr.pageSize = e
      this.obr.page = 1
      this.value1 = 2
      this.list()
    },
    fetchCurrentPage(e) {
      this.newarrs = []
      this.newarrs = this.arrs
      console.log(this.newarrs, 'this.newarrs')
      this.obr.page = e
      this.value1 = 2
      this.list()
    },
    set(id) {
      this.arrs.forEach((item) => {
        if (item.user_id === id) {
          item.tips = false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}

.que_box {
  margin-top: 20px;
}

.have {
  color: #409eff;
}

.search_icon {
  margin-left: 10px;
}

.band_box {
  display: flex;
}

.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}

.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}

.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}

.choose_blockr {
  background: #409eff;
}

.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}

:-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.choiceofficialaccount {
  margin-bottom: 10px;
}

.select_spacing {
  margin-bottom: 5px;
}

.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.switch_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.band_box>>>.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  display: none;
}
</style>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}

.que_box {
  margin-top: 20px;
}

.have {
  color: #409eff;
}

.serch_box {
  display: flex;
  margin-bottom: 10px;
}

.search_icon {
  margin-left: 10px;
}

.band_box {
  display: flex;
}

.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}

.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}

.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}

.choose_blockr {
  background: #409eff;
}

.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}

:-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.choiceofficialaccount {
  margin-bottom: 10px;
}

.select_spacing {
  margin-bottom: 5px;
}

.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.addbutton {
  margin-bottom: 20px;
}

.name-item {
  margin-right: 10px;
}

.vertical-line {
  border-left: 1px solid #ccc;
  height: 320px;
  /* 设置线条的高度 */
  margin-right: 15px;
}

.name-item {
  margin-right: 10px;
}

.checkbox-list {
  display: flex;
  flex-direction: column;
}

.checkbox-item {
  margin-bottom: 5px;
}

.checkbox-list {
  width: 300px;
  flex-wrap: wrap;
  max-height: 300px;
  overflow-y: auto;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #438ff7;
  /* 设置背景颜色为透明 */
  border-color: #438ff7;
  /* 设置边框颜色为透明 */
}
.select-box{
  display:flex;
  margin-left: 70px;
}
@media (max-width: 768px){
  .select-box{
    flex-direction:column;
    margin:0px !important;
  }
  .selected-box{
    margin-top:5vw;
  }
  .el-select{
    width:auto !important;
  }
  .el-input--medium .el-input__inner{
    width:40vw !important;
  }
  .warning-text{
    font-size:3vw;
  }
  .el-col-8{
    width:20%;
  }
}
</style>
